import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, Tooltip } from 'recharts';
import { safeNum, safeArray } from '../../../utils/gpsFormUtils';
import { VIOLET } from './constants';
import ExplorerNotice from './ExplorerNotice';

const DATE_AXIS_CAPTION =
  'Date issue de la réponse au formulaire (distincte de la date de création utilisée pour filtrer la période).';

const DateView = ({ breakdown }) => {
  const current =
    breakdown?.current && typeof breakdown.current === 'object' ? breakdown.current : {};
  const timeline = safeArray(current.timeline)
    .filter((p) => p && p.date != null)
    .map((p) => ({ date: String(p.date), count: safeNum(p.count) }));

  if (timeline.length === 0) {
    return <ExplorerNotice>Aucune date exploitable pour cette question.</ExplorerNotice>;
  }

  return (
    <div data-testid="explorer-date">
      <div className="h-[240px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={timeline} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
            <defs>
              <linearGradient id="formDateGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={VIOLET} stopOpacity={0.4} />
                <stop offset="95%" stopColor={VIOLET} stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              style={{ fontSize: '12px' }}
            />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="count"
              stroke={VIOLET}
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#formDateGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">{DATE_AXIS_CAPTION}</p>
    </div>
  );
};

export default DateView;
